import imgBlock1Bg from './img/block1背景.png'
import imgBlock1BgAi from './img/block1背景ai.png'

import React, {useEffect, useRef} from "react";
import {observer} from "mobx-react";
import css from './block1.module.scss'
import Block1Card1 from "./Block1Card1";
import Block1SearchFloor from "./Block1SearchFloor";
import Block1LeftCarousel from "./Block1LeftCarousel";
import Block1NewsPanel from "./Block1NewsPanel";
import Block1Card2 from "./Block1Card2";
import classNames from "classnames";
import {makeAutoObservable} from "mobx";
import Swiper from "swiper";

class RightCarouselStore {
    list = [
        {
            img: require('./img/block1右侧直播宣传1.png')
        },
        {
            img: require('./img/block1右侧直播宣传2.png')
        }
    ]
    curIndex = 0

    setList(value) {
        this.list = value
    }

    setCurIndex(value) {
        this.curIndex = value
    }

    get cur() {
        return this.list?.[this.curIndex]
    }

    constructor() {
        makeAutoObservable(this)
    }
}

const rightCarouselStore = new RightCarouselStore()

const Block1RightCarousel = observer(() => {
    const swiperRef = useRef()

    useEffect(() => {
        if (!(swiperRef.current && rightCarouselStore.list.length)) {
            return;
        }

        const mySwiper = new Swiper(swiperRef.current, {
            slidesPerView: 1,
            loop: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            on: {
                slideChange() {
                    rightCarouselStore.setCurIndex(this.activeIndex % rightCarouselStore.list.length);
                }
            }
        })


        //鼠标覆盖停止自动切换
        swiperRef.current.onmouseover = function () {
            mySwiper.autoplay.stop();
        }

        //鼠标离开开始自动切换
        swiperRef.current.onmouseout = function () {
            mySwiper.autoplay.start();
        }
    }, [swiperRef.current, rightCarouselStore.list.length]);

    useEffect(() => {
        console.log(`index:${rightCarouselStore.curIndex}`)
    }, []);

    function slideTo(index) {
        swiperRef.current.swiper.slideTo(index)
    }

    return (
        <div className="w-[216px]">
            <div className="swiper w-[216px] overflow-x-hidden relative z-0" ref={swiperRef}>
                <div className="swiper-wrapper z-0">
                    {
                        rightCarouselStore.list.map((item, index) => {
                            const {img} = item;
                            return (
                                <div key={index} className="swiper-slide w-[216px] h-[292px]">
                                    <img className="w-[216px] h-[292px] rounded-[20px] object-contain" src={img}
                                         alt=''/>
                                </div>
                            )
                        })
                    }
                </div>
                <div className="absolute flex justify-center z-10 bottom-[8px] left-0 right-0">
                    {
                        rightCarouselStore.list.map((_, index) => {
                            const isFirst = index === 0;
                            const active = index === rightCarouselStore.curIndex
                            return (
                                <div key={index}
                                     className={classNames("w-[19px] h-[3px] rounded-[2px] bg-[#FFFFFF]/60", {
                                         ["ml-[11px]"]: !isFirst,
                                         ["bg-[#7399FA]!"]: active
                                     })}>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
})


const Index = (
    {
        navFloor,
        aiConfig
    }
) => {
    return (
        <div className={classNames(css.root, aiConfig.open === true ? css.hasAi : css.normal)}>
            {
                aiConfig.open
                    ? <img src={imgBlock1BgAi} className={classNames(css.imgBg,css.hasAi)} alt=""/>
                    : <img src={imgBlock1Bg} className={classNames(css.imgBg,css.normal)} alt=""/>
            }

            <div className={css.container}>

                {/* banner */}
                {navFloor}

                {/* card1 */}
                <Block1Card1 className={css.card1}>
                    {/* 搜索floor 所有分类 输入框 我的购物车 菜单icon*/}
                    <Block1SearchFloor className={css.searchFloor}/>

                    <div className={css.bottomFloor}>
                        {/*轮播*/}
                        <Block1LeftCarousel className={css.carouselContainer}/>
                        {/*右侧包含 广告 登录 公告*/}
                        <div className={css.rightContainer}>
                            {
                                aiConfig.open
                                    ? <Block1RightCarousel/>
                                    : <div className={css.advWrapper}>
                                        <img className={css.img}
                                             src={require('./img/block1右侧直播宣传1.png')} alt=''/>
                                    </div>
                            }
                            <Block1NewsPanel className={css.newsPanel}/>
                        </div>
                    </div>
                </Block1Card1>

                {/* card2 秒杀 */}
                <Block1Card2 aiConfig={aiConfig}/>

            </div>
        </div>
    )
}

export default observer(Index)